import React from "react";
import HomeScreen from "../homescreen/homescreen";

class NewHome extends HomeScreen {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
        };
    }

    renderHomeContent() {
        return (
            <div>
                <div className='sectionInnerTitle'><span>06/01/2025 -  </span><b>Game Map Editor</b></div>
                <p className='sectionDescription'>First post of the year! And it's to announce that there is a new tool available to play, a map editor for an HTML game (the game prototype that I shared before).</p>
                <p className='sectionDescription'>The editor for now is pretty basic, and it doesn't have that many assets yet, but it has enough features to deserve a place here. Unfortunately it doesn't have a built-in tutorial, so here are some key features/hints if you want to give it a go:</p>
                <p className='sectionDescription'>
                    <ul>
                        <li>The editor loads after all the assets are available (will add a loading dialog later on).</li>
                        <li>You can navigate the map with the arrow keys, and zoom in and out with <b>+</b> and <b>-</b></li>
                        <li>There is a main combo box to select the type of assets. For now it allows you to place ground tiles and items.</li>
                        <li>The menu has some attributes that are not being used in the editor itself (ie. if the ground tile is "walkable" or not).</li>
                        <li>You can create a new map, save and load them. The data is stored locally (local storage).</li>
                    </ul>
                </p>
                <p className='sectionDescription'>The editor can be found <a href='https://mapeditor.condemakoto.com/'><b>here</b></a>. Please, feel free to give it a try. If you have any <b>comment/feedback</b>, leave them in the <a href={'/contact'}>contact section</a>, and I'll gladly go through them :)</p>
                <a href='https://mapeditor.condemakoto.com/'><img src={'/assets/editor_screenie.png'} style={{width: '100%', height: '100%', marginTop: '12px'}}/></a>
                <br></br><br></br>
                <p className='sectionDescription'>The game prototype of the game can be <a href='https://test.condemakoto.com/'>here</a>). </p>
                <br></br><br></br>


                <div className='sectionInnerTitle'><span>30/12/2024 -  </span><b>Farewell 2024</b></div>
                <img src='/assets/news_2024.png' style={{width: '100%', height: '100%'}}/>
                <br></br><br></br>

                <p className='sectionDescription'>We embarked on many new adventures, including setting foot in the far East—an unknown land for us—where we unlocked our first of seven achievements while exploring the vast and enduring Great Wall of China. Along the way, we met new people whose cultures were different from ours, but who shared more common values and goals than we could have imagined.</p>
                <br></br>
                <p className='sectionDescription'>In sports, we made notable progress, valiantly fighting our way to the top in some events, though we were also defeated in many others. Some of those battles left scars and injuries that will take time to heal, but the rewards—trophies, medals, and, most importantly, the fun and friendships—made it all worthwhile.</p>
                <br></br>
                <p className='sectionDescription'>I'm confident that the 2025 update will bring even more quests for us to tackle.</p>
                <br></br>

                <div className='sectionInnerTitle'><span>04/11/2024 -  </span><b>More updates coming</b></div>
                <p className='sectionDescription'>A while has passed since I've uploaded the first version of the website, and finally I decided to officially make some changes around here. </p>
                <p className='sectionDescription'>The <a href='./gallery'>gallery</a> has been growing in the past month, and the picture viewer was revamped as well. I know, it's still not as user friendly as it can be, but will invest more time on time as soon as I finish with other projects. As for the content, I've been trying to cover more and more badminton events (in which I also participated), and some other exciting photo shoots. If you happen to be interested in shooting together, drop be me a message (you can do so <a href='./contact'>here</a>).</p>
                <br></br>
                <p className='sectionDescription'>I'm also updating other sections in the site. An example is a demo of the first version of an HTML 5 game I started a couple of years ago, but that have never seen the light until now. I've been refactoring it as a multiplayer game, and will soon give more updates on that.</p>
                <br></br>

                <div className='sectionInnerTitle'><span>03/10/2021 -  </span><b>First New</b></div>
                <p className='sectionDescription'>Welcome to my website!</p>
                <br></br>
                <p className='sectionDescription'>After many many months, I finally could make some time to update the site. I added a gallery where I'll be sharing photos and drawings/paintings. </p>
                <p className='sectionDescription'>Hopefully it won't take that long until the next time.</p>
            </div>
        );
    }

    getScreenName() {
        return 'Home';
    }
}

export default NewHome;


// WEBPACK FOOTER //
// ./src/screens/newhome/home.js